import { createApiHook } from './hooks';
import { validationsApiFactory } from './validationsApi';

export const useValidationsApi = createApiHook(validationsApiFactory);
